import React from 'react';

import './style.css';

const MobileToggle = ({ onClick }) => {
    return (
        <svg className="mobile-toggle" viewBox="0 0 10 8" width="40" onClick={onClick ?? undefined}>
            <path d="M1 1h8M1 4h 8M1 7h8" stroke="#138ce9" strokeWidth="2" strokeLinecap="round" />
        </svg>
    );
};

export default MobileToggle;
